export default __webpack_public_path__ + "static/media/logo.2abcd2f9.png";